import { useFm } from '@web3/base-hooks';

export const TermNConditions = () => {
  const fm = useFm();

  return (
    <div className="main flex flex-col justify-center pt-20">
      <div className="semi-bold-24 mb-4">{fm('termsAndConditions')}</div>
      <ol className="list-decimal pl-4">
        <li className="mb-4">
          <span className="regular-16">{fm('TC6')}</span>
          <div className="mt-2 ml-0">
            <div className="regular-16">{fm('TC7')}</div>
            <ul className="list-disc pl-4 mt-2">
              <li className="regular-16">{fm('TC8')}</li>
              <li className="regular-16">{fm('TC9')}</li>
              <li className="regular-16">{fm('TC10')}</li>
            </ul>
          </div>
        </li>
        <li className="regular-16 mb-4">{fm('TC11')}</li>
        <li className="regular-16 mb-4">{fm('TC12')}</li>
        <li className="regular-16 mb-4">{fm('TC13')}</li>
      </ol>
    </div>
  );
};
